import React, {FC, Fragment, useEffect, useState} from 'react'
import {Button} from 'antd';
import UserActionModal from "../UserAction.modal";
import {useForm} from "@/hooks/useForm";
import SendBackActionForm from "./SendBackAction.form";
import {useLang} from "@/hooks/useLang";

const initialState  = {
    fileList:[],
    fields: {
        name_en: null,
        name_bn: null,
        status: 1,
    },
    isNewRecord: true,
    loading: false,
}

const SendBackActionController: FC<any> = props => {
    const { t } = useLang();
    const { applicationData, handleActionSendBack, handleCallbackFunc } = props;
    const { formRef, initialValues, isSubmitting, setIsSubmitting, handleChange, handleSubmitFailed, resetForm } = useForm(initialState.fields);

    const [isShowFormModal, setIsShowFormModal] = useState(false);
    const [reloadForm, setReloadForm] = useState<number>(Date.now());
    const [fileList, setFileList] = useState<any[]>(initialState.fileList);
    const [loading, setLoading] = useState(initialState.loading);

    const modalTitle = 'Send Back';
    const submitBtnText = `Yes, Send Back`;
    const confirmText = `Are you sure to send back this application?`;

    useEffect(() => {
        resetForm();
    }, [reloadForm])

    const showFormModal = (): void => {
        setIsShowFormModal(true);
        handleReloadForm();
    }

    const hideFormModal = () => {
        setIsShowFormModal(false);
    }

    const handleReloadForm = () => {
        setReloadForm(Date.now());
    };

    const handleCallback = (event:any, action: string, recordId?:any, data?: any) => {
        if (action === 'hideForm') {
            hideFormModal();
        }
        else if (handleCallbackFunc) {
            handleCallbackFunc(event, action, recordId, data);
        }
    }

    const handleSubmit = (values: any): void => {
        handleCreate(values);
    }

    const handleCreate = (values: any): void => {
        const payload = {
            comment: values.comment,
            files: fileList.map(item => item.file_id).join(','),
        }
        handleActionSendBack(payload);
        handleCallback(null, 'hideForm');
    }

    return (
        <Fragment>
            <UserActionModal
                loading={loading}
                formRef={formRef}
                modalTitle={modalTitle}
                submitBtnText={submitBtnText}
                confirmText={confirmText}
                isSubmitting={isSubmitting}
                isShowFormModal={isShowFormModal}
                initialValues={initialValues}
                applicationData={applicationData}
                fileList={fileList}
                setFileList={setFileList}
                component={SendBackActionForm}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                handleSubmitFailed={handleSubmitFailed}
                handleCallbackFunc={handleCallback}
            />
            <Button type="primary" className="btn btn-submit btn-transition" onClick={() => showFormModal()}>{t('Send Back')}</Button>
        </Fragment>
    );
}
export default React.memo(SendBackActionController);
